// extracted by mini-css-extract-plugin
export var button = "roundButton-module--button--O8hY+";
export var sNew = "roundButton-module--sNew--uyjs1";
export var sGame = "roundButton-module--sGame--WXfIs";